/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBarsSort: {
  name: 'bars-sort';
  data: string;
} = {
  name: 'bars-sort',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 4a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 0 1H1A.5.5 0 0 1 .5 4Zm0 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H1A.5.5 0 0 1 .5 8Zm.5 3.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H1Z" fill="currentColor"/></svg>`,
};
